import { lccstore } from '@holmescorp/lcc-state';
import { XAPI } from '@holmescorp/xapi';
import { ActivityDefinition } from '@holmescorp/xapi/classes/activity_definition';
const commonSetup = (quiz) => {
    const { get, path } = lccstore;
    const assoc = get(path('title')).toLowerCase();
    const product = get(path('product'));
    const id = `${product}:${quiz.id}`;
    const authority = new XAPI.Group({
        name: `${assoc}`,
        mbox: `${assoc}@example.com`
    });
    const definition = new ActivityDefinition({
        type: 'http://adlnet.gov/expapi/activities/assessment',
        name: { 'en-US': quiz.title }
    });
    const target = new XAPI.Activity({
        id,
        name: quiz.title,
        more_info: quiz.kind,
        definition
    });
    return { authority, target };
};
export const recordStart = (quiz, isRestart = false) => {
    const { get, path } = lccstore;
    const actor = get(path('actor_xapi'));
    const { authority, target } = commonSetup(quiz);
    const verb = isRestart ? XAPI.Verbs.ABANDONED : XAPI.Verbs.PROGRESSED;
    const result = new XAPI.Result({
        extensions: {
            'https://w3id.org/xapi/cmi5/result/extensions/progress': 0
        }
    });
    const statement = new XAPI.Statement({ actor, target, verb, result, authority }).asVersion();
    return XAPI.svc.set_statement({ stmnt: statement });
};
export const recordProgress = (quiz, info, cursor, percent) => {
    const { numberofquestions, currentpage } = info;
    const allowedValues = numberofquestions > 20 ? [0, 25, 50, 75] : [0, 50];
    const position = cursor || currentpage;
    const chunkSize = Math.floor(numberofquestions / allowedValues.length);
    const estimated = position % chunkSize === 0 ? allowedValues[position / chunkSize] : (position / numberofquestions) * 100;
    const progress = percent || estimated;
    if ((numberofquestions < 5 && progress > 0) || !allowedValues.includes(progress)) {
        return;
    }
    const { get, path } = lccstore;
    const actor = get(path('actor_xapi'));
    const { authority, target } = commonSetup(quiz);
    const verb = XAPI.Verbs.PROGRESSED;
    const result = new XAPI.Result({
        extensions: {
            'https://w3id.org/xapi/cmi5/result/extensions/progress': progress
        }
    });
    const statement = new XAPI.Statement({ actor, target, verb, result, authority }).asVersion();
    return XAPI.svc.set_statement({ stmnt: statement });
};
export const recordComplete = (lastresult, scores, quiz) => {
    const { runningtime, totalpercentcorrect, numbercorrect, numberofquestions } = lastresult;
    const { get, path } = lccstore;
    const actor = get(path('actor_xapi'));
    const { authority, target } = commonSetup(quiz);
    const [hours = 0, minutes = 0, seconds = 0] = runningtime.split(':');
    const verb = XAPI.Verbs.COMPLETED;
    const score = new XAPI.Score({ scaled: totalpercentcorrect, raw: numbercorrect, max: numberofquestions });
    const result = new XAPI.Result({
        completion: true,
        score,
        duration: `PT${hours}H${minutes}M${seconds}S`,
        extensions: scores
    });
    const statement = new XAPI.Statement({ actor, target, verb, result, authority }).asVersion();
    return XAPI.svc.set_statement({ stmnt: statement });
};
